import { render, staticRenderFns } from "./SbolErrors.vue?vue&type=template&id=bef3e6aa&scoped=true&"
import script from "./SbolErrors.vue?vue&type=script&lang=js&"
export * from "./SbolErrors.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "bef3e6aa",
  null
  ,true
)

export default component.exports